import Mock, { Random } from 'mockjs'
export default {
	ApiLogin: Mock.mock({
		code: 200,
		data: {
			list: {
				username: '',
				password: '',
			},
			token: '',
		},

		message: '',
	}),
}
